export default () => ({
  projectId: undefined,
  pipelineId: undefined,
  pipelineJobsPath: '',
  isLoading: false,
  pipelineJobs: [],
});
